<template>
  <v-container>
    <v-text-field
      label="Оценка (баллы)"
      v-model="legalProtectionScore"
      outlined
      readonly
      filled
    />
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { GETTERS, MUTATIONS } from "@/store";

export default {
  name: "TheLegalProtectionScore",
  components: {},
  data: () => ({}),
  props: {},
  computed: {
    ...mapGetters({ card: GETTERS.CARD_DATA }),

    legalProtectionScore() {
      const legalProtection = {
        "01": 10,
        "02": 7,
        "03": 5,
        "04": 2,
        "05": 3,
        "06": 2,
        "07": 0,
      };
      const values = this.card.legalProtection || [];
      const value = values.reduce(
        (accumulator, currentValue) =>
          accumulator + legalProtection[currentValue],
        0
      );
      if (this.card.legalProtectionScore !== value) {
        this.modify({ legalProtectionScore: value });
      }
      return value;
    },
  },
  methods: {
    ...mapMutations({
      modify: MUTATIONS.MODIFY_CARD_DATA,
    }),
  },
};
</script>
